import { render, staticRenderFns } from "./distributionorderAdd.vue?vue&type=template&id=be35ccec&scoped=true&"
import script from "./distributionorderAdd.vue?vue&type=script&lang=js&"
export * from "./distributionorderAdd.vue?vue&type=script&lang=js&"
import style0 from "./distributionorderAdd.vue?vue&type=style&index=0&id=be35ccec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be35ccec",
  null
  
)

export default component.exports